// Hands the chosen service from the profile page to the existing booking
// wizard. The wizard restores its selection from sessionStorage (see
// useBookingFlow), so we write the service there and move to the date/time step.
export function bookingWizardSearch(serviceId: number, current: string = window.location.search): string {
  sessionStorage.setItem('booking_service', JSON.stringify(serviceId));
  sessionStorage.removeItem('booking_slot');
  sessionStorage.removeItem('booking_date');

  const params = new URLSearchParams(current);
  params.set('step', '1');
  params.delete('slot');
  return `?${params.toString()}`;
}
